import { translate } from '../../../common/helpers/translate.helper';
import { useCreateVesselProduct } from '../hooks/useCreateVesselProduct';

import { VesselProductModal } from './VesselProductModal';

interface AddVesselProductModalProps {
    isOpen: boolean;
    onDismiss: () => void;
    vesselId: string;
    excludedProductIds?: string[];
}

export const AddVesselProductModal = ({
    isOpen,
    onDismiss,
    vesselId,
    excludedProductIds,
}: AddVesselProductModalProps) => {
    const createMutation = useCreateVesselProduct(vesselId);

    const handleSubmit = async (values: { productId: string; note: string }) => {
        const trimmedNote = values.note.trim();
        await createMutation.mutateAsync({
            vesselProduct: {
                productId: values.productId,
                note: trimmedNote || undefined,
            },
        });
    };

    return (
        <VesselProductModal
            isOpen={isOpen}
            onDismiss={onDismiss}
            onSubmit={handleSubmit}
            initialValues={{
                productId: '',
                note: '',
            }}
            title={translate('vessel.products.addModal.title')}
            isLoading={createMutation.isPending}
            vesselId={vesselId}
            excludedProductIds={excludedProductIds}
        />
    );
};
